import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOObjectApi } from '@/api/pto/object'
import { getUserFullName } from '@/utils/user'
import { priceFormat } from '@/utils/form/priceFormat'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOObjectApi,
  namePageDetailed: 'PtoObjectDetailed',
  expand: 'building,status,estimate_responsible,general_contractor,treaty,customer,updated_by,price,signed,remains',
  tableHeaders: [
    {
      title: 'Дата начала',
      isSortable: true,
      sortName: 'start_date'
    },
    {
      title: 'Дата окончания',
      isSortable: true,
      sortName: 'stop_date'
    },
    {
      title: 'Кто изменил',
      isSortable: true,
      sortName: 'updated_by.surname'
    },
    {
      title: 'Стройка',
      isSortable: true,
      sortName: 'building.name'
    },
    {
      title: 'Наименование объекта',
      isSortable: true,
      sortName: 'name'
    },
    {
      title: 'Статус',
      isSortable: true,
      sortName: 'status.name'
    },
    {
      title: 'Субподрядчик Интекс',
      isSortable: false,
      sortName: 'is_intex'
    },
    {
      title: 'Ответственный сметный',
      isSortable: true,
      sortName: 'estimate_responsible.surname'
    },
    {
      title: 'Генподрядчик',
      isSortable: true,
      sortName: 'general_contractor.short_name'
    },
    {
      title: 'Г/П к вычету %',
      isSortable: true,
      sortName: 'deduction'
    },
    {
      title: 'Договор',
      isSortable: true,
      sortName: 'treaty.treaty_number'
    },
    {
      title: 'Заказчик',
      isSortable: true,
      sortName: 'customer.short_name'
    },
    {
      title: 'Стоимость',
      isSortable: true,
      sortName: 'price'
    },
    {
      title: 'Подписано',
      isSortable: true,
      sortName: 'signed'
    },
    {
      title: 'Остаток',
      isSortable: true,
      sortName: 'remains'
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getList: (state) => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.start_date || '-',
          item.stop_date || '-',
          getUserFullName(item.updated_by) || '-',
          item.building?.name || '-',
          item.name || '-',
          item.status?.name || '-',
          item.is_intex ? 'Да' : 'Нет',
          getUserFullName(item.estimate_responsible) || '-',
          item.general_contractor?.long_name || '-',
          priceFormat(item.deduction) || '-',
          item.treaty?.treaty_number || '-',
          item.customer?.long_name || '-',
          item.price !== 0 ? priceFormat(item.price) : '-',
          item.signed !== 0 ? priceFormat(item.signed) : '-',
          item.remains !== 0 ? priceFormat(item.remains) : '-'
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
